module.exports = __webpack_public_path__ + "img/arrow-back.89cba02c.svg";